import BoxZoomIcon from '@apps-common/ui-icons/BoxZoom.jsx';
import PropTypes from 'prop-types';
import React from 'react';

import MapPopperButton from './MapPopperButton.jsx';

const BoxZoom = props => {
  const {active, onClick} = props;

  return (
    <MapPopperButton
      tooltip="Select an area to zoom to"
      color={active ? 'primary' : undefined}
      onClick={onClick}
    >
      <BoxZoomIcon />
    </MapPopperButton>
  );
};

BoxZoom.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
};

export default BoxZoom;
